/**
 * Get a single rule level per rules level type.
 * Gets the rule which is most granular: Machine > Site > Fleet.
 * @param ruleLevels the rule levels to filter
 * @param machineId the machine id
 * @param severityTypes the list of available rule level types
 * @returns {*[]} a list of rule levels
 */
export const getRuleLevelPerSeverityType = (
  ruleLevels,
  machineId,
  severityTypes
) => {
  // Filter the thresholds to ones only related to the current machine
  const relatedRuleLevels = ruleLevels.filter(
    x => x.machine_id === null || x.machine_id === machineId
  );

  // Only show one threshold per rules level type
  const relevantRuleLevels = [];
  severityTypes.forEach(severityType => {
    const threshold = relatedRuleLevels.find(
      x =>
        x.rule_level_type_id === severityType.id &&
        (x.machine_id !== null || x.site_id !== null || true)
    );

    if (threshold) {
      relevantRuleLevels.push(threshold);
    }
  });

  return relevantRuleLevels;
};
